import MigrationNoteDTO from '@src/adapters/dto/migration/MigrationNoteDTO';
import useApi, { ApiOptions } from '../base/useApi';
interface Params {
  note: MigrationNoteDTO;
  migrationId: string;
}

interface Result {
  note: MigrationNoteDTO;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/migration/save_note/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};
export const useSaveMigrationNote = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useSaveMigrationNoteLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveMigrationNote;
